module.exports = __webpack_public_path__ + "static/media/host-a-php-server-with-docker.f9290d21.md";